import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import MaterialConfigEmpty from 'components/MaterialConfigEmpty/MaterialConfigEmpty';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IImportFileModal from './interfaces/IImportFileModal';

import styles from './scss/ImportFileModal.module.scss';

function ImportFileModal({
  open, title, onCloseModal, uploadControl, onDownloadExample,
  titleBox, subTitleBox, titleWrapper, subTitleWrapper, hideSubTitleWrapper,
}: IImportFileModal) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={title || ''}
      className={styles.modalContainer}
      isButtonsVisible={false}
    >
      <div className={styles.root}>
        <div className={styles.formWrapper}>
          <MaterialConfigEmpty
            title={titleWrapper}
            subTitle={subTitleWrapper}
            uploadControl={uploadControl}
            onDownloadExample={onDownloadExample}
            titleBox={titleBox}
            subTitleBox={subTitleBox}
            hideSubTitleWrapper={hideSubTitleWrapper}
          />
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={onCloseModal}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ImportFileModal;
